import { action } from "@ember/object"
import Component from "@glimmer/component"

interface Sig {
  Args: {
    accept: (shouldDeleteLessons: boolean) => void
    decline: () => void
  }
}

export default class ConfirmDeleteUnit extends Component<Sig> {
  @action
  onKeydown(event: KeyboardEvent) {
    if (event.key === "Enter") {
      event.stopPropagation()
      this.args.accept(false)
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Dialogs::ConfirmDeleteUnit": ConfirmDeleteUnit
  }
}
